module.exports = __webpack_public_path__ + "img/H01061-70.6af8bbd5.jpg";